import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function WhatsAppFloat() {
  return (
    <a
      href={BRAND.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="WhatsApp Kiap Yong"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-whatsapp animate-pulse-ring" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-whatsapp ring-4 ring-bronze/30 shadow-lg shadow-bronze/30 group-hover:scale-105 transition-transform duration-300">
        <MessageCircle className="text-white" size={26} strokeWidth={2} fill="white" />
      </span>
      <span className="hidden md:block absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-ink text-cream text-[0.65rem] tracking-[0.22em] uppercase px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        WhatsApp Kiap Yong
      </span>
    </a>
  );
}
